import { render, staticRenderFns } from "./RecipientSelector.vue?vue&type=template&id=06ff451c&scoped=true"
import script from "./RecipientSelector.vue?vue&type=script&lang=js"
export * from "./RecipientSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff451c",
  null
  
)

export default component.exports